import React, { ReactNode } from 'react';
import Portal from '../portal/portal';
import './modal.css';
import { IcoClose } from '../icon/icon';
import { Button } from '../button/button';

export interface IModalProps {
  title: string | JSX.Element;
  children: ReactNode | ReactNode[];
  open: boolean;
  close: any;
  closeText?: string;
  size?:
    | 'small'
    | 'medium'
    | 'large'
    | 'large-full'
    | 'large-full-height'
    | 'fullscreen';
  actions?: any;
  borderHeader?: boolean;
  cy: string;
  closeBtnClasses?: string;
  hasCancelBtn?: boolean;
}

export const Modal: React.FC<IModalProps> = ({
  title,
  children,
  open = false,
  close,
  closeText = 'Cancelar',
  size = 'medium',
  actions,
  cy,
  borderHeader = false,
  closeBtnClasses,
  hasCancelBtn = true,
}) => {
  // VERIFICAR SE ESSA CONDIÇÃO AINDA FAZ O QUE É ESPERADO DELA
  if (!Array.isArray(children)) {
    children = [children];
  }
  return (
    <Portal name="modal">
      {open
        ? size === 'fullscreen'
          ? fullscreen({
              title,
              open,
              children,
              size,
              closeText,
              close,
              actions,
              cy,
              borderHeader,
              closeBtnClasses,
              hasCancelBtn,
            })
          : modalNormal({
              title,
              open,
              children,
              size,
              closeText,
              close,
              actions,
              cy,
              borderHeader,
              closeBtnClasses,
              hasCancelBtn,
            })
        : null}
    </Portal>
  );
};

const fullscreen: React.FC<IModalProps> = ({
  title,
  children,
  closeText,
  close,
  actions,
  cy,
  borderHeader,
  closeBtnClasses = '',
  hasCancelBtn,
}) => {
  return (
    <div
      className={`box-modal fullscreen`}
      data-cy={`ModalFullScreenFullContainer${cy}`}
      id={`Modal${cy}FullContainer`}
    >
      <div className="modal-header" data-cy={`ModalFullScreen${cy}Header`}>
        {title}
        {actions ? (
          <div
            className="modal-actions"
            data-cy={`ModalFullScreen${cy}Actions`}
          >
            {hasCancelBtn && (
              <Button
                className={`btn secondary normal ${closeBtnClasses}`}
                onClick={close}
                cy={`ModalFullScreenClose${cy}`}
              >
                {closeText}
              </Button>
            )}
            {actions}
          </div>
        ) : null}
      </div>
      <div className="modal-content" data-cy={`Modal${cy}ContentContainer`}>
        {children}
      </div>
    </div>
  );
};

const modalNormal: React.FC<IModalProps> = ({
  title,
  children,
  size,
  closeText,
  close,
  actions,
  cy,
  borderHeader,
  closeBtnClasses = '',
  hasCancelBtn,
}) => {
  return (
    <div className={`box-modal`} data-cy={`Modal${cy}FullContainer`}>
      <div
        className={`size-${size}`}
        data-cy={`Modal${size}${cy}Container`}
        id={`Modal${size}${cy}FullContainer`}
      >
        <div className="modal-header-container">
          <div className="modal-header" data-cy={`Modal${size}${cy}Header`}>
            {title}
            <Button
              className="modal-close"
              onClick={close}
              title={closeText}
              cy={`Modal${size}${cy}Close`}
            >
              <IcoClose cy={`Modal${cy}`} />
            </Button>
          </div>
          {borderHeader ? <div className="modal-border-header" /> : <></>}
        </div>
        <div
          className="modal-content"
          data-cy={`Modal${size}${cy}ContentContainer`}
        >
          {children}
        </div>
        {actions ? (
          <div
            className="modal-actions"
            data-cy={`Modal${size}${cy}ActionsContainer`}
          >
            {hasCancelBtn && (
              <Button
                color="secondary"
                variant="outline"
                onClick={close}
                className={`modal-close-btn ${closeBtnClasses}`}
                cy={`Modal${size}${cy}Close`}
              >
                {closeText}
              </Button>
            )}
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
};
